
import { Component, Prop, Watch, Mixins, Emit } from "vue-property-decorator";
import api from "@/services/api.service";
import OnTestTable from "./OnTestTable.vue";
import PutOnTest from "./alarm-points/PutOnTest.vue";
import { ServerDetails, ServerTableDetails, ServerType } from "@/store/devices/types";
import { namespace } from "vuex-class";
import { ServerListPaginatedSearchQueryParams } from "@/store/types";
import PaginatedSearch, { PaginatedSearchRequest } from "@/mixins/PaginatedSearch";
import { formatDateMixin } from "@/mixins";

const Devices = namespace("devices");
const Areas = namespace("areas");
const { convertUtcDateTimeToLocalDateTimeString } = formatDateMixin.methods;

@Component({
  components: {
    "on-test-table": OnTestTable,
    "put-on-test": PutOnTest
  }
})

export default class DevicesOnTest extends Mixins(PaginatedSearch) {
  @Prop({ type: Number, required: true }) private groupId: number;
  @Prop({ type: Boolean, default: true, required: false }) private showTitle: boolean;
  @Prop({ type: String, default: null, required: false }) private searchQuery: string;
  

  @Areas.Getter private getAreaTitle: (id: number) => string;
  @Devices.State private serverTypes: ServerType[];
	@Devices.Action private getDeviceTypes: () => Promise<void>;

  private serverList: ServerDetails[] = [];
  private selectedPage: number = 1;
  private resultsPerPage: number = 25;
  private totalServerCount: number = null;
  private tableServerList: ServerTableDetails[] = [];
  private putOnTestMode: boolean = false;
  private extendTestMode: boolean = false;
  private selectedServer: ServerDetails | null = null;

  private async mounted(): Promise<void> {
    await this.fetchServers({ groupId: this.groupId, page: this.selectedPage, pageSize: this.resultsPerPage });
  }

  @Watch("groupId")
  private async onGroupIdChange(): Promise<void> {
    await this.fetchServers({ groupId: this.groupId, page: this.selectedPage, pageSize: this.resultsPerPage });
  }

  private async fetchServers(paginatedSearchQueryParams : ServerListPaginatedSearchQueryParams): Promise<void> {
    if (!this.groupId) {
      return;
    }

    paginatedSearchQueryParams.groupId = this.groupId;
    const cancellableQuery: PaginatedSearchRequest = this.generateNewPaginatedSearchRequest(paginatedSearchQueryParams);
    cancellableQuery.params.groupId = this.groupId;

    const result = await api.getServers(cancellableQuery);
    this.serverList = result.data;
    this.tableServerList = await this.setTableDetails();
    this.totalServerCount = result.totalRecords;
  }

  private async setTableDetails(): Promise<ServerTableDetails[]> {
    await this.getDeviceTypes();

    this.serverList.forEach(async (server: ServerTableDetails): Promise<void> => {
      if (server.onTest && server.onTestUntil) {
        server.onTestColumnText = "On Test Until: " + convertUtcDateTimeToLocalDateTimeString(server.onTestUntil);
      }
      else {
        server.onTestColumnText = "";
      }

      server.groupName = this.getAreaTitle(server.groupID);

			server.deviceTypeTitle = this.getServerTypeById(server.serverTypeID)?.title;
    })

    return this.serverList;
  }

  private getServerTypeById(serverTypeID: number): ServerType {
		return this.serverTypes.find(({ serverTypeID: id }: ServerType) => id == serverTypeID);
	}

  @Emit("reset-search")
  private async openOnTest(selectedServer : ServerDetails): Promise<void> {
    this.selectedServer = (await api.getServer(selectedServer.serverID)).data;
    this.putOnTestMode = true;

    if (selectedServer.onTest) {
      this.extendTestMode = true;
    }
  }

  private get isSearchQueryPropProvided(): boolean {
      return this.searchQuery != null
  }

  private async close(): Promise<void> {
    this.putOnTestMode = false;
    this.extendTestMode = false;

    await this.fetchServers({ groupId: this.groupId, page: this.selectedPage, pageSize: this.resultsPerPage });
  }
}
